import { useAppDispatch, useAppSelector } from "../../hooks";
import { Page } from "../Dawer/drawerTypes";
import { openDrawer } from "../Dawer/drawerSlice";
import './TopBar.css';
import { getWriterId } from "../../Features/SalesDep/Managers/SalesRepView/WriterSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { SvgIconComponent } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { openWelcomeModal } from "../../Features/Shared/Dashboard/Welcome Modal/WelcomeUISlice";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";
import { getTodoCount } from "../../Features/SalesDep/To-Do List/TodoSelectors";
import { Notifications } from "@mui/icons-material";
import { Badge } from "@mui/material";

const TopBar = ({ page }: { page: Page }) => {
    const dispatch = useAppDispatch();
    const currentWriter = useAppSelector(getWriterId);
    const taskValue = useAppSelector(getTodoCount);
    const notifications = useAppSelector((state) => state.notifications.pushNotifArr);

    const handleClick = async () => {
        dispatch(openWelcomeModal());
        logEvent(analytics, 'user_notifs', {
            name: 'notification bell',
            description: 'User opened notification menu'
        })
    };

    return (
        <div
            className="topbar bg-primary text-light d-flex align-items-center px-3"
            style={{ flex: 1, userSelect: 'none' }}
        >
            {/* Left side: Page icon, label, and writer */}
            <div
                className="d-flex align-items-center"
                style={{ gap: 10 }}
            >
                <div
                    onClick={
                        page.type === 'back'
                            ? () => window.history.back()
                            : () => dispatch(openDrawer())
                    }
                    className="d-flex align-items-center"
                    style={{ cursor: 'pointer' }}
                >
                    {page.iconType === 'mui' ? (
                        (() => {
                            const Icon = page.icon as SvgIconComponent;
                            return <Icon />;
                        })()
                    ) : page.iconType === 'fa-comp' ? (
                        <FontAwesomeIcon
                            icon={page.icon as IconDefinition}
                            size="lg"
                            style={{ paddingInlineEnd: 10 }}
                        />
                    ) : (
                        <i
                            className={`${page.icon}`}
                            style={{ paddingInlineEnd: 10 }}
                        />
                    )}

                    <h5 className="m-0">
                        {page.label}
                    </h5>

                    {currentWriter && (
                        <h5
                            className="m-0"
                            style={{ color: 'red' }}
                        >
                            ({currentWriter})
                        </h5>
                    )}
                </div>
            </div>

            {/* Right side: Notification bell */}
            {page.label === 'Dashboard' && (
                <IconButton
                    onClick={handleClick}
                    className="ms-auto"
                >
                    {(notifications?.length || taskValue > 0) &&
                        <Badge
                            color="error"
                            badgeContent={notifications.length + taskValue}
                        >
                            <Notifications sx={{ color: "white" }} />
                        </Badge>
                    }
                </IconButton>
            )}
        </div>
    );
};

export default TopBar;